module.exports = __webpack_public_path__ + "static/media/table-tennis.90251344.jpg";